import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Button } from "../App.styles";
import { ConfirmationModal, withPlaceholder } from "../common";
import Datalist from "../datalist";
import { groupsUri } from "../lib/refresh";
import {
    deleteIdState as deleteId,
    notificationState as notification,
    pageState as page,
    pageSizeState as pageSize,
} from "./Groups.state";
import DatalistPlaceholder from "../datalist/DatalistPlaceholder";
import GroupsEmpty from './GroupsEmpty'

const DeleteGroup = (confirmationProps) => {
    // passing t as prop instead of using useTranslation hook directly here
    // to comply with the [rules of hooks](https://reactjs.org/docs/hooks-rules.html)
    const { t, ...props } = confirmationProps
    return (
        <ConfirmationModal 
          title={t("Delete Group" )}
          body={t("Are you sure you wish to delete this group?")}
          confirmLabel={t("Yes, delete")}
          {...props}
        >
            <Button
              color="danger"
              className="btn-raised"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
        </ConfirmationModal>
    )
}

const Groups = () => {
    const { t } = useTranslation();
    const { game_id } = useParams();
    
    return (
        <Datalist
            dataId="group"
            sidebar={{
                message: t('Setup teams in advance or change them up during the game. The first group will be used as the default group that teams are added to upon joining the game.'),
                panel: null,
            }}
            states={{
                deleteId,
                notification,
                page,
                pageSize,
            }}
            partials={{
                delete: DeleteGroup,
            }}
            refresher={{
                subscriptions: 'ss.group.create,ss.group.delete,ss.group.update',
                uri: groupsUri(game_id),
            }}
            empty={GroupsEmpty}
        />
    )
}

export default withPlaceholder(Groups, DatalistPlaceholder)